var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
var defaultSortParam = 'descripcion';
var defaultSortDirection = 'asc';
var MaquinasFilterService = /** @class */ (function (_super) {
    __extends(MaquinasFilterService, _super);
    function MaquinasFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaquinasFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('idZBMaquinaParkeon', (filter.SomId ? filter.SomId.toString() : ''))
            .append('descripcion', filter.descripcio)
            .append('numPlazas', (filter.numPlazas ? filter.numPlazas.toString() : ''))
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return MaquinasFilterService;
}(CustomFilterService));
export { MaquinasFilterService };
